import { BASE_URL, CORPORATE_TOPIC} from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";


export async function getCorporateTopics(params: string = ""): Promise<any[]> {
  const response = await axios.get(BASE_URL + CORPORATE_TOPIC + params);
  return response.data;
}
export async function addCorporateTopics(data: any[]) {
  const response = await axios.post(BASE_URL + CORPORATE_TOPIC, data);
  return response.data;
}

export async function editCorporateTopic(data: any,id:string) {
  const response = await axios.patch(BASE_URL + CORPORATE_TOPIC+"/"+id, data);
  return response.data;
}

export async function deleteCorporateTopic(id: string) {
  const response = await axios.delete(BASE_URL + CORPORATE_TOPIC + "/" + id);
  return response.data;
}

export const CorporateTopicsCells: HeadCell[] = [

  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
 
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
